/**
 * KennelRouter - Smart router for /hodowla/:slug
 * Renderuje PublicKennel (v1) DOMYŚLNIE od razu (bez czekania na API).
 * Po pobraniu template_version, jeśli to v3, przełącza się.
 * Dzięki temu Googlebot widzi content + Helmet meta tags natychmiast.
 */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import { API_BASE as API } from '@/utils/api';
import { KennelUnclaimedBanner } from '@/components/KennelComplianceNotice';
import PublishedHeroBlock from '@/components/PublishedHeroBlock';
import NewPageOnboarding from '@/components/NewPageOnboarding';

// Lazy imports — V1 jest preloaded (główny case), V3 tylko gdy potrzebne
const PublicKennel = React.lazy(() => import('@/pages/PublicKennel'));
const PublicKennelV3 = React.lazy(() => import('@/pages/PublicKennelV3'));

export default function KennelRouter() {
  const { slug } = useParams();
  // Domyślnie v1 — Googlebot widzi content od razu, nie czeka na API
  const [templateVersion, setTemplateVersion] = useState('v1');

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/api/public/hodowla/${slug}`);
        const version = res.data?.kennel?.template_version || 'v1';
        if (version !== 'v1') {
          setTemplateVersion(version);
        }
      } catch {
        // Pozostaje v1
      }
    })();
  }, [slug]);

  return (
    <>
      <NewPageOnboarding kind="kennel" />
      <PublishedHeroBlock entityType="kennel" slug={slug} />
      <KennelUnclaimedBanner slug={slug} />
      <React.Suspense fallback={null}>
        {templateVersion === 'v3' ? <PublicKennelV3 /> : <PublicKennel />}
      </React.Suspense>
    </>
  );
}
